import { CustomError } from './sendSaveUtils';
import { ComposeViewState } from 'owa-mail-compose-store';
import getErrorMessageFromResponseCode from './getErrorMessageFromResponseCode';
import { isFeatureEnabled } from 'owa-feature-flags';
import { presentHipChallengeOnSendFail } from './presentHipChallengeOnSendFail';
import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';
import getDetailErrorInfobarHandler from './getDetailErrorInfobarHandler';
import { UNDO_SEND_ERROR_MESSAGE } from './sendConstants';
import { CANCEL_SMIME_SEND_ERROR_MESSAGE } from 'owa-smime/lib/utils/constants';

export function handleSendErrorResponse(
    error: CustomError,
    viewState: ComposeViewState,
    isSend: boolean
) {
    if (
        error.message == UNDO_SEND_ERROR_MESSAGE ||
        error.message == CANCEL_SMIME_SEND_ERROR_MESSAGE
    ) {
        return;
    }

    const messageId = getErrorMessageFromResponseCode(error ? error.message : null, isSend);

    if (
        messageId == 'errorMessageMessageSubmissionBlocked' &&
        isFeatureEnabled('cmp-hipCheckChallengeOnSendFail') &&
        isFeatureEnabled('cmp-hipCheckModal')
    ) {
        // Instead of presenting an infobar for users in these 2 flights,
        // immediately spawn the modal that the infobar's button would have opened.
        presentHipChallengeOnSendFail(viewState);
    }

    if (messageId == 'errorMessageMessageCanNotBeSent' && error.messageText) {
        // Add detailed message text to common send failure error infobar
        addInfoBarMessage(
            viewState,
            'errorMessageErrorWithDetail',
            getDetailErrorInfobarHandler(error.messageText)
        );
    } else {
        addInfoBarMessage(viewState, messageId);
    }
}
